import { createStore, createEvent } from 'effector';

// Типы
export interface LoadingState {
  isLoading: boolean;
  loadingText: string;
  loadingCount: number;
}

// События
export const setLoading = createEvent<boolean>();
export const setLoadingText = createEvent<string>();
export const incrementLoading = createEvent();
export const decrementLoading = createEvent();
export const resetLoading = createEvent();

// Store
export const loadingStore = createStore<LoadingState>({
  isLoading: false,
  loadingText: 'Загрузка...',
  loadingCount: 0,
})
  .on(setLoading, (state, isLoading) => ({ 
    ...state, 
    isLoading,
    loadingCount: isLoading ? Math.max(1, state.loadingCount) : 0 
  }))
  .on(setLoadingText, (state, loadingText) => ({ ...state, loadingText }))
  .on(incrementLoading, (state) => ({ 
    ...state, 
    loadingCount: state.loadingCount + 1,
    isLoading: true 
  }))
  .on(decrementLoading, (state) => {
    const newCount = Math.max(0, state.loadingCount - 1);
    return { 
      ...state, 
      loadingCount: newCount,
      isLoading: newCount > 0 
    };
  })
  .on(resetLoading, (state) => ({ 
    ...state, 
    isLoading: false,
    loadingCount: 0 
  }));

// Селекторы
export const $isLoading = loadingStore.map(state => state.isLoading);
export const $loadingText = loadingStore.map(state => state.loadingText);
export const $loadingCount = loadingStore.map(state => state.loadingCount);
